// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"StyleSetting--next-sr-only--2zNkil0","container":"StyleSetting--container--3iNgSl2","buttonsWrapper":"StyleSetting--buttonsWrapper--3H0Riai"};